import 'bootstrap';

document.addEventListener("DOMContentLoaded", () => {
  const hasAdultCookie = document.cookie.includes("adult=true");

  if (!hasAdultCookie) {
    setTimeout(() => {
      let ageGateModal = $('#ageGateModal');
      ageGateModal.modal('show');
    }, 300);
  }
});